(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bump-cart"]) return;
  try {
    

  document.querySelectorAll("[id^='BumpDrawer-']").forEach((element) => {
    const msDelay = Number(element.dataset.delay) * 1000;

  if (document.querySelector("[id^='BumpDrawer-']").classList.contains("toCart")) return;
  else {
    if (msDelay >= 0) {
      setTimeout(() => {
        // A/B: window.cart_bump_ab === true suppresses the auto-open for the
        // variant group. Read it when the timer fires, not at load: this file
        // runs before Intelligems has loaded its config, so a flag set by the
        // experiment is never there yet at load.
        // Manual QA override: ?ab_cart_bump=b forces variant, ?ab_cart_bump=a forces control.
        const forced = (location.search.match(/[?&]ab_cart_bump=([ab])/) || [])[1];
        const suppress = forced ? forced === 'b' : window.cart_bump_ab === true;
        if (suppress) return;
        element.show();
      }, msDelay);
    }
  };
  });

  /* Offer Timer */
  const countdownTimer = document.getElementById('offer-timer-countdown');
  let minutes = 2;
  let seconds = 00;

  function updateTimer() {
    // Format time string with leading zeros
    const formattedMinutes = minutes.toString().padStart(2, '0');
    const formattedSeconds = seconds.toString().padStart(2, '0');
    if (countdownTimer)
      countdownTimer.textContent = `${formattedMinutes}:${formattedSeconds}`;

    // Decrement seconds and update minutes if necessary
    seconds--;
    if (seconds === -1) {
      seconds = 59;
      minutes--;
    }

    // Check if timer has reached zero
    if (minutes === 0 && seconds === 0) {
      minutes = 2
    }
  }
  // Start the timer with an interval of 1 second
  function startTimer(){
    minutes = 2
    secionds = 00
  }

  const intervalId = setInterval(updateTimer, 1000);

  // Update the timer initially (optional)
  updateTimer();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.body = document.querySelector('body');
      this.mql = window.matchMedia(`(min-width: ${window.breakpoints.lg}px)`);
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.onMediaMatchHandler = this.createObserver.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.mql.addListener(this.onMediaMatchHandler);
      this.createObserver();
    }
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      this.mql.removeListener(this.onMediaMatchHandler);
    }
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }
    onScroll() {
      const raw = window.pageYOffset || document.documentElement.scrollTop;
      const maxScroll = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
      if (raw >= maxScroll - 4) {
        this.currentScrollTop = maxScroll;
        return;
      }
      const scrollTop = Math.max(0, raw);
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide() {
      this.body.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.body.classList.remove('shopify-header-revealed');
    }
    reveal() {
      this.body.classList.add('shopify-section-header-sticky', 'animate', 'shopify-header-revealed');
      this.body.classList.remove('shopify-section-header-hidden');
    }
    reset() {
      this.body.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  /*
  const pinchZoom = (imageElement) => {
    let imageElementScale = 1;

    let start = {};

    // Calculate distance between two fingers
    const distance = (event) => {
      return Math.hypot(event.touches[0].pageX - event.touches[1].pageX, event.touches[0].pageY - event.touches[1].pageY);
    };

    imageElement.addEventListener('touchstart', (event) => {
      console.log('touchstart', event);
      if (event.touches.length === 2) {
        event.preventDefault(); // Prevent page scroll

        // Calculate where the fingers have started on the X and Y axis
        start.x = (event.touches[0].pageX + event.touches[1].pageX) / 2;
        start.y = (event.touches[0].pageY + event.touches[1].pageY) / 2;
        start.distance = distance(event);
      }
    });

    imageElement.addEventListener('touchmove', (event) => {
      console.log('touchmove', event);
      if (event.touches.length === 2) {
        event.preventDefault(); // Prevent page scroll
        let scale;

        // Safari provides event.scale as two fingers move on the screen
        // For other browsers just calculate the scale manually
        if (event.scale) {
          scale = event.scale;
        } else {
          const deltaDistance = distance(event);
          scale = deltaDistance / start.distance;
        }

        imageElementScale = Math.min(Math.max(1, scale), 4);

        // Calculate how much the fingers have moved on the X and Y axis
        const deltaX = (((event.touches[0].pageX + event.touches[1].pageX) / 2) - start.x) * 2; // x2 for accelarated movement
        const deltaY = (((event.touches[0].pageY + event.touches[1].pageY) / 2) - start.y) * 2; // x2 for accelarated movement

        // Transform the image to make it grow and move with fingers
        const transform = `translate3d(${deltaX}px, ${deltaY}px, 0) scale(${imageElementScale})`;
        imageElement.style.transform = transform;
        imageElement.style.WebkitTransform = transform;
        imageElement.style.zIndex = "9999";
      }
    });


  }
  document.querySelectorAll('.product-image-modal__content > *').forEach(image => {
    console.log('pinchZoom turning on.')
    pinchZoom(image)
  });
  */

  document.querySelectorAll('product-form button[type="submit"]').forEach((element) => {
    element.addEventListener('click', (event) => {
      const selector = document.querySelector('.product__info-wrapper');
      if (!selector) return;

      const matches = window.matchMedia('(max-width: 767px)').matches;

      // Only scroll when the add will actually go through — jumping the page on a
      // validation failure (no size picked) or a disabled button is disorienting.
      const form = element.form || element.closest('form');
      const willSubmit = !element.disabled && (!form || form.checkValidity());

      if (matches && willSubmit) {
        selector.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });

  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(
        `[data-image-id]:not([data-image-id="${this.openedBy.getAttribute('data-image-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-image-id="${this.openedBy.getAttribute('data-image-id')}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      if (container) container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMediaContent &&
        activeMediaContent.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  class ImageNavigation extends HTMLElement {
    constructor() {
      super();

      this.bindEvents();
    }

    bindEvents() {
      const root = document.querySelector(this.querySelector('a').getAttribute('href')).parentElement;

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const element = this.querySelector(`[href='#${entry.target.id}']`);
            if (entry.isIntersecting) {
              element.setAttribute('aria-current', 'location');
              element.classList.add('active');
            } else {
              element.removeAttribute('aria-current');
              element.classList.remove('active');
            }
          });
        },
        { root, threshold: 0.5 }
      );

      [...this.querySelectorAll('a')].forEach((element) => {
        const image = document.querySelector(element.getAttribute('href'));
        observer.observe(image);
        element.addEventListener('click', this.onClick.bind(this));
      });
    }

    onClick(event) {
      event.preventDefault();
      const image = document.querySelector(event.currentTarget.getAttribute('href'));
      document.querySelector('sticky-header').dispatchEvent(new CustomEvent('preventHeaderReveal'));
      const container = image.parentElement;
      if (container) {
        container.scrollTo({ left: image.offsetLeft, behavior: 'smooth' });
      }
    }
  }

  customElements.define('image-navigation', ImageNavigation);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scrolling-announcement-bar"] && !Shopify.designMode) return;
  try {
    
// JavaScript goes here

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wished-product-recommendations"] && !Shopify.designMode) return;
  try {
    
  // Two saved products that aren't in the cart yet, rendered as listing cards
  // (sections/wished-product-recommendation.liquid). Saved items come from
  // MNWishlistStore (assets/wishlist-store.js); the card's own form adds to cart.
  (function () {
    var sections = document.querySelectorAll('.wished-product-recommendations');
    if (!sections.length) return;

    var render = async function (store) {
      // However long the list takes: a slow first load is retried in the
      // background, and these still show when it lands.
      await store.whenLoaded();
      var cart = await fetch(window.routes.cart_url + '.js').then(function (response) {
        return response.json();
      });
      var inCart = new Set(cart.items.map(function (lineItem) { return lineItem.product_id; }));
      var seen = new Set();
      var items = store.items().filter(function (item) {
        if (!item.itemId || !item.handle || inCart.has(item.productId) || seen.has(item.productId)) return false;
        seen.add(item.productId);
        return true;
      });
      if (items.length < 2) return;

      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var sectionToRender = 'wished-product-recommendation';
      var elements = await Promise.all(
        items.slice(0, 2).map(function (item) {
          var url = root + 'products/' + encodeURIComponent(item.handle);
          var query = '?sections=' + sectionToRender + (item.variantId ? '&variant=' + item.variantId : '');
          return fetch(url + query)
            .then(function (response) { return response.json(); })
            .then(function (json) {
              var listItemElement = document.createElement('li');
              listItemElement.dataset.productId = item.productId;
              listItemElement.dataset.variantId = item.variantId || '';
              listItemElement.dataset.productUrl = url;
              listItemElement.classList.add('grid__item');
              listItemElement.innerHTML = json[sectionToRender];
              return listItemElement;
            });
        })
      );

      sections.forEach(function (section) {
        var sectionToFill = section.querySelector('.grid');
        elements.forEach(function (element) {
          sectionToFill.appendChild(sections.length === 1 ? element : element.cloneNode(true));
        });
        section.classList.remove('hidden');
        if (window.lazyloadPolyfill) window.lazyloadPolyfill(section);
        if (window.convertCurrency) window.convertCurrency(section);
      });
    };

    var start = function (store) {
      render(store).catch(function (error) {
        console.error('Wishlist recommendations failed', error);
      });
    };
    if (window.MNWishlistStore) {
      start(window.MNWishlistStore);
    } else if (window.MNWishlistEnabled) {
      document.addEventListener('mn:wishlist-store', function () { start(window.MNWishlistStore); }, { once: true });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
